import React from "react";
import locale from "@bonliva-crm/locale";
import { FormTab } from "@components/forms/common/FormTab";
import FormSection from "@components/forms/common/FormSection";
import { EmergencyContactInfo } from "../sections/EmergencyContactInfo";
import { CompetitorInfo } from "../sections/CompetitorInfo";
import { TravelInfo } from "@consultants/ConsultantEditor/sections/TravelInfo";
import { Text } from "@components/formx";

export function MiscTab() {
  return (
    <FormTab horizontal>
      <FormSection fitted>
        <FormSection title={locale["ICE number"]} fullWidth>
          <EmergencyContactInfo />
        </FormSection>
      </FormSection>

      <FormSection fitted>
        <FormSection title={locale["Works via competitors"]} fullWidth>
          <CompetitorInfo />
        </FormSection>
        <FormSection fullWidth title={"Resepreferenser"} style={{ marginTop: 16 }}>
          <TravelInfo />
        </FormSection>
        <FormSection fullWidth title={"Boendepreferenser"} style={{ marginTop: 16 }}>
          <div>
            <Text
              TextFieldProps={{ multiline: true }}
              name={"personal.accommodationPreferences"}
            />
          </div>
        </FormSection>
        <FormSection fullWidth title={locale.consultantCare} style={{ marginTop: 16 }}>
          <div>
            <Text TextFieldProps={{ multiline: true }} name={"personal.care"} />
          </div>
        </FormSection>
      </FormSection>
    </FormTab>
  );
}
